/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CFMSpecialty = {
  properties: {
    name: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'DoctorSpecialtyType',
      isRequired: true,
    },
  },
} as const;
